module.exports = __webpack_public_path__ + "static/media/chime.1ca50b69.mp3";